import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { api } from "../../../../resources/api";
import { toast } from "react-toastify";
import Loader from "../../../common/loader/loader";
import PageHeader from "../../../common/pageheader/pageheader";
import SearchSelect from "../../../common/select/SearchSelect";
import { useForm } from "react-hook-form";
import { encryptData, projectDomain } from "../../../../resources/constants";

function AddStudentPortal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, setValue } = useForm();
  const [studentSelectList, setStudentSelectList] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState({ StudentID: "", FirstName: "", EmailAddress: "" });
  const [studentList, setStudentList] = useState([]);

  const addStudentPortalClick = async (data) => {
    if (data.ID === "") { toast.error("Please specify student ID"); return; }
    if (data.email2 === "") { toast.error("Please specify student private email"); return; }
    const dataTo = { ...data, ID: selectedStudent.StudentID, password: encryptData("123456789") };
    const { success, message } = await api.post("staff/users/student-manager/add-student-portal", dataTo);
    if (success) { toast.success(message || "Student portal added successfully"); }
    else { toast.error("An error has occurred. Please try again!"); }
  };

  const getStudentDetails = async () => {
    const { success, data: result } = await api.get("staff/student-manager/student/active");
    if (success && result?.length > 0) {
      let rows = [];
      result.forEach((item) => { rows.push({ value: item.StudentID, label: `${item.FirstName} ${item.MiddleName} ${item.Surname} (${item.StudentID})` }); });
      setStudentSelectList(rows);
      setStudentList(result);
    }
  };

  const handleChange = (e) => {
    const filter_student = studentList.filter((i) => i.StudentID === e.value);
    if (filter_student.length > 0) {
      setSelectedStudent({ StudentID: filter_student[0].StudentID, FirstName: filter_student[0].FirstName, EmailAddress: filter_student[0].EmailAddress });
      setValue("username", (filter_student[0].FirstName + "" + filter_student[0].StudentID.slice(filter_student[0].StudentID.length - 4)).toLowerCase());
      setValue("email2", filter_student[0].EmailAddress.toLowerCase());
      setValue("email", (filter_student[0].FirstName + "" + filter_student[0].StudentID.slice(filter_student[0].StudentID.length - 4) + projectDomain).toLowerCase());
    }
  };

  useEffect(() => { getStudentDetails(); }, []);

  return isLoading ? (<Loader />) : (
    <div className="d-flex flex-column flex-row-fluid">
      <PageHeader title={"Add Student Portal"} items={["Users", "Student Manager", "Add Student Portal"]} />
      <div className="flex-column-fluid"><div className="card"><div className="card-body p-0"><form onSubmit={handleSubmit(addStudentPortalClick)}><div className="form-group pt-5"><label htmlFor="roomNumber">Student ID</label><SearchSelect value={studentSelectList.find(op => op.value === selectedStudent.StudentID) || null} onChange={handleChange} options={studentSelectList} placeholder="Search Student" /></div><div className="form-group pt-5"><label htmlFor="roomNumber">Username</label><input {...register("username")} id="username" required disabled placeholder="Enter Username" className="form-control" /></div><div className="form-group pt-5"><label htmlFor="email">Email Address</label><input {...register("email")} disabled id="email" required type="email" placeholder="Enter Email Address" className="form-control" /></div><div className="form-group pt-5"><label htmlFor="email2">Private Email Address</label><input {...register("email2")} id="email2" required disabled type="email" placeholder="Enter Private Email Address" className="form-control" /></div><div className="form-group pt-5"><button className="btn btn-primary w-100">Save</button></div></form></div></div></div>
    </div>
  );
}

const mapStateToProps = (state) => { return { loginData: state.LoginDetails[0] }; };
export default connect(mapStateToProps, null)(AddStudentPortal);
